import React from "react";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Locations } from "./components/Locations";
import { MenuSection } from "./components/Menu";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { VideoSection } from "./components/VideoSection";
import { SocialMedia } from "./components/SocialMedia";
import { Footer } from "./components/Footer";
import { Toaster } from "sonner";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <Header />
        <main>
          <Hero />
          <About />
          <Locations />
          <MenuSection />
          <Gallery />
          <Reviews />
          <VideoSection />
          <SocialMedia />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
